import { HELP_CENTER_LOGIN_URL } from "@/apps/official/constants";

/** 官网顶栏菜单（一级）；key 为 vue-router 路径，或以 http(s):// 开头的外链 */
export const defaultMenus = [
  { id: "m-1", name: "首页", key: "/", children: [] },
  { id: "m-2", name: "产品", key: "/products/oms", children: [] },
  { id: "m-3", name: "案例", key: "/cases", children: [] },
  // { id: "m-4", name: "帮助中心", key: HELP_CENTER_LOGIN_URL, children: [] },
  { id: "m-5", name: "关于我们", key: "/about", children: [] }
];

/** 首页「核心能力」图标卡片 */
export const defaultCapabilityValues = [
  {
    id: "cap-1",
    icon: require("@/static/icon/1.jpg"),
    title: "全链路系统打通",
    desc: "整合 OMS、WMS、ERP、DRP、BI，实现从订单到履约、从库存到财务的数据闭环。"
  },
  {
    id: "cap-2",
    icon: require("@/static/icon/2.jpg"),
    title: "多平台多渠道支持",
    desc: "对接主流跨境电商平台，统一管理多店铺、多渠道订单与库存。"
  },
  {
    id: "cap-3",
    icon: require("@/static/icon/3.jpg"),
    title: "智能仓储管理",
    desc: "支持多仓、多区域库存管理，优化拣货、打包、发货效率。"
  },
  {
    id: "cap-4",
    icon: require("@/static/icon/4.png"),
    title: "数据驱动决策",
    desc: "通过 BI 系统实时分析业务数据，让运营更精准、更可控。"
  }
];

/** 首页「我们能为你带来的价值」 */
export const defaultCoreValues = [
  {
    id: "cv-1",
    icon: require("@/static/icon/1.jpg"),
    title: "提升效率",
    desc: "自动化订单处理，减少人工操作，整体运营效率提升 30%+。"
  },
  {
    id: "cv-2",
    icon: require("@/static/icon/2.jpg"),
    title: "降低成本",
    desc: "优化库存结构与仓储流程，降低仓储与履约成本。"
  },
  {
    id: "cv-3",
    icon: require("@/static/icon/3.jpg"),
    title: "数据可视化",
    desc: "实时掌握销售、库存、利润数据，决策更科学。"
  },
  {
    id: "cv-4",
    icon: require("@/static/icon/4.png"),
    title: "支持全球业务扩展",
    desc: "多语言、多币种、多仓支持，助力企业全球化发展。"
  }
];

/** 首页「核心功能」区块默认数据（版式为 CoreFeaturesSection；文案与核心能力一致） */
export const defaultCoreFeatures = [
  {
    id: "cf-1",
    image: require("@/static/official/core-feature-1.jpg"),
    title: "全链路系统打通",
    subtitle: "OMS / WMS / ERP / DRP / BI 一体化",
    detail:
      "整合 OMS、WMS、ERP、DRP、BI，实现从订单到履约、从库存到财务的数据闭环。"
  },
  {
    id: "cf-2",
    image: require("@/static/official/core-feature-2.jpg"),
    title: "多平台多渠道支持",
    subtitle: "统一多店铺、多渠道",
    detail: "对接主流跨境电商平台，统一管理多店铺、多渠道订单与库存。"
  },
  {
    id: "cf-3",
    image: require("@/static/official/core-feature-3.jpg"),
    title: "智能仓储管理",
    subtitle: "多仓协同，柔性履约",
    detail: "支持多仓、多区域库存管理，优化拣货、打包、发货效率。"
  },
  {
    id: "cf-4",
    image: require("@/static/official/core-feature-4.jpg"),
    title: "数据驱动决策",
    subtitle: "BI 实时分析，运营可度量",
    detail: "通过 BI 系统实时分析业务数据，让运营更精准、更可控。"
  }
];

export const defaultBasicInfo = {
  logo: "https://oss.seacang.com/logo/eshop-logo.png",
  companyName: "驿店科技有限公司",
  preSalesPhone: "13128460609",
  afterSalesPhone: "18852735045",
  email: "chenweiwen@eshoperp.com",
  filingNumber: "粤ICP备2024346063号-2",
  policeFilingNumber: "",
  address: "广东省深圳市龙岗区中浩二路22号亿源通产业园F栋501",
  contactQrCode: require("@/static/contact-qrcode.png"),
  wechatQrCode: require("@/static/official/wechat-placeholder.png")
};

/** 首页合作伙伴：图标来自 @/static/home（打包后由 webpack 输出 URL；后台可改为 OSS） */
export const defaultPartners = [
  {
    id: "pt-lazada",
    name: "Lazada",
    logo: require("@/static/home/lazada.png"),
    website: "https://www.lazada.com"
  },
  {
    id: "pt-shopee",
    name: "Shopee",
    logo: require("@/static/home/shopee.png"),
    website: "https://shopee.com"
  },
  {
    id: "pt-tiktok",
    name: "TikTok",
    logo: require("@/static/home/tiktok.png"),
    website: "https://www.tiktok.com"
  },
  {
    id: "pt-mabang",
    name: "马帮",
    logo: require("@/static/home/mabang.png"),
    website: "https://www.mabangerp.com"
  },
  {
    id: "pt-miaoshou",
    name: "妙手",
    logo: require("@/static/home/miaoshou.png"),
    website: "https://www.miaoshou.com"
  },
  {
    id: "pt-bigseller",
    name: "BigSeller",
    logo: require("@/static/home/bigseller.png"),
    website: "https://www.bigseller.com"
  },
  {
    id: "pt-xinjian",
    name: "心舰",
    logo: require("@/static/home/xinjian.png"),
    website: ""
  },
  {
    id: "pt-qianyi",
    name: "千易",
    logo: require("@/static/home/qianyi.png"),
    website: ""
  },
  {
    id: "pt-asinking",
    name: "领星",
    logo: require("@/static/home/lingxing.png"),
    website: "https://www.asinking.com"
  },
  {
    id: "pt-shopify",
    name: "Shopify",
    logo: require("@/static/home/shopify.png"),
    website: "https://www.shopify.com"
  },
  {
    id: "pt-temu",
    name: "TEMU",
    logo: require("@/static/home/temu.png"),
    website: "https://www.temu.com"
  },
  {
    id: "pt-haicang",
    name: "海仓",
    logo: require("@/static/home/seacang.png"),
    website: ""
  },
  {
    id: "pt-shanyi",
    name: "闪衣",
    logo: require("@/static/home/shanyi.png"),
    website: ""
  }
];

/** 关于我们页面 */
export const defaultAboutPage = {
  image: require("@/static/official/about.jpg"),
  title: "关于我们",
  subtitle: "专注跨境电商与跨境仓储信息化",
  detail:
    "我们专注于跨境电商与跨境仓储行业的信息化建设，拥有多年行业经验与技术积累。公司以技术驱动为核心，通过自主研发的系统产品，持续为客户提供稳定、高效、可扩展的解决方案。",
  richHtml: `
<h3>我们的使命</h3>
<p>通过技术赋能跨境企业，让全球贸易更高效、更智能。</p>
<h3>我们的愿景</h3>
<p>成为跨境电商与仓储数字化领域的领先技术服务商。</p>
<h3>核心优势</h3>
<ul>
<li><strong>行业经验：</strong>深耕跨境电商与仓储领域，理解业务痛点。</li>
<li><strong>技术实力：</strong>自主研发核心系统，持续迭代升级。</li>
<li><strong>客户导向：</strong>根据客户业务需求提供定制化方案。</li>
<li><strong>稳定服务：</strong>高可用系统与专业技术支持团队。</li>
</ul>
`.trim()
};

/** 产品详情页 slug，与路由 /products/:slug、产品 id prd-{slug} 一致 */
export const PRODUCT_SLUGS = ["oms", "wms", "hwc", "erp", "drp", "bi", "tms", "suyuan", "pingce", "chat"];

const productPoints = {
  oms: [
    {
      title: "多平台订单中枢归集",
      body: "电商平台、独立站与自有系统订单统一接入与主数据对齐，减少多后台切换与表格汇总，为履约、客服与经营分析提供单一可信数据源。"
    },
    {
      title: "规则化拆合单与履约成本可控",
      body: "按仓网、承运、时效承诺与毛利目标自动编排拆单、合单；策略支持仿真与灰度，在保障 SLA 的前提下压缩物流单量与人工干预成本。"
    },
    {
      title: "履约全链路可视与协同",
      body: "从审单、下发仓内到轨迹回传与客户签收全程可追溯，关键节点可预警、可订阅，客服与仓储同屏协同，降低客诉升级与对内扯皮成本。"
    },
    {
      title: "风险单前置拦截与留痕",
      body: "地址异常、库存缺口、风控命中等问题单自动分流待审，减少错发、漏发与纠纷；处理路径与责任人留痕，便于内控复核与持续优化规则。"
    }
  ],
  hwc: [
    {
      title: "工作台与经营看板",
      body: "订单待操作、新增客户、充值与消费等核心 KPI 一屏呈现，近 7 日出库量按国家/站点拆分趋势图，管理层与仓内主管随时掌握业务脉搏。"
    },
    {
      title: "客户订单与商品资料协同",
      body: "客户账号、店铺、商品资料库与客户订单统一管理，多平台订单按待预报、待确认、操作中等状态流转，减少 Excel 跟单与跨部门口头协调。"
    },
    {
      title: "WMS 仓内作业一体化",
      body: "发货、入库、出库、库存与仓库对账模块内置，运单/退货/调拨入库全流程状态可视，收货、上架、拣配任务与 OMS 订单严格对应。"
    },
    {
      title: "费用设置与多币种结算",
      body: "基础费用、外汇汇率、收款账号、充值策略与用户折扣集中配置，佣金、仓租、贴标、发货等收费项按仓点与客户灵活定价，多币种自动换算。"
    }
  ],
  wms: [
    {
      title: "企业级多仓与库内建模",
      body: "库区、批次、效期、序列号等维度可配置，满足合规、差异化存储与追溯要求；多仓协同与可售策略支撑规模化扩张而不失控。"
    },
    {
      title: "标准化入库出库与波次作业",
      body: "采购到货、销退、调拨等场景流程固化；出库按波次、截单与承运分区自动编排任务队列，降低对熟练工的依赖、缩短出库周期。"
    },
    {
      title: "拣货动线与人效优化",
      body: "按库位动线与订单结构合并拣货任务，支持边拣边分、先拣后播等模式；可对接 PDA/电子标签等，以可度量的方式持续提升仓内人效。"
    },
    {
      title: "账实一致与中台联动",
      body: "上架、拣发、盘点等节点实时回写可售与存货账，与 OMS/ERP 对齐口径，降低超卖、断货与财务对账差异，支撑精细化成本核算。"
    }
  ],
  erp: [
    {
      title: "进货下单到货一站管",
      body: "采购单、到货、对账不用来回切表格和微信，供应商交期与在途一目了然；结合销量自动提醒补货，少断货、也少囤一堆卖不动的货。"
    },
    {
      title: "每件货真实成本算得清",
      body: "把采购价、头程、关税、平台扣点摊到 SKU 和每一单上，看清到底是真赚钱还是表面热闹，决定要不要继续投、要不要清仓止损。"
    },
    {
      title: "库存占了多少货款心里有数",
      body: "各仓、各平台可售与在途库存同屏呈现，哪些快断货、哪些压货款一眼看出，补货和促销更有底气，少让呆滞库存占住周转现金。"
    },
    {
      title: "小团队也能分工协作",
      body: "多店铺、多仓库权限分开管，采购、运营、财务各看各的账又数据同源；不用上大系统，两三个人也能把进销存和日常对账跑顺。"
    }
  ],
  drp: [
    {
      title: "经销商主数据与授信管控",
      body: "档案、合同、等级与授信集中维护，下单与回款状态实时可查；权限与可售目录按区域与等级隔离，降低渠道运营与对账沟通成本。"
    },
    {
      title: "多级渠道与业绩归属清晰",
      body: "省代、市代、门店等多级架构可配置，返利、阶梯价与活动政策按时间窗发布；业绩归属规则明确可追溯，减少年度结算与渠道纠纷。"
    },
    {
      title: "价盘与特价审批留痕",
      body: "价目表与渠道特价分层管理，突破底价走审批并全程留痕；协同直营与平台大促节奏，在冲量的同时守住品牌价格体系。"
    },
    {
      title: "分货与库存协同",
      body: "分销订单路由总仓或区域仓，可售共享、安全水位与分货策略可配；在途与退货与财务核销联动，降低渠道断货、重复备库与资金占压。"
    }
  ],
  bi: [
    {
      title: "多店铺业绩随时看",
      body: "各平台店铺、链接和 SKU 的销量与成交额集中呈现，今日卖了多少、哪个爆款在涨，不用切十几个后台导表，打开手机也能扫一眼。"
    },
    {
      title: "成本厘清，真赚钱才继续做",
      body: "把平台扣点、广告、运费、仓储摊到每一件货、每一单上，看清到底是真赚钱还是表面热闹，帮你决定要不要加码投流、要不要清仓止损。"
    },
    {
      title: "库存心里有数，少压货款",
      body: "哪些货卖不动、哪些快断货一目了然，该补货还是该促销更有底气，少让呆滞库存占住本可以周转的现金。"
    },
    {
      title: "图表报告零门槛",
      body: "现成的看板与日报，点几下就能换时间、换店铺看，不用啃复杂表格；关键数字还能提醒，大促盯盘少熬夜。"
    }
  ],
  pingce: [
    {
      title: "店铺与多平台管理",
      body: "统一管理 Shopee、TikTok、Amazon 等跨境平台店铺与站点，商品链接、负责人与站点信息集中维护，多店评测业务一处发起、全局可查。"
    },
    {
      title: "任务发布与刷手接单",
      body: "企业发布评测、引流、真实单等任务并设定佣金与排期，刷手在线抢单/接单；买手账号池与刷手档案联动，任务从待确认到完成全程可追踪。"
    },
    {
      title: "评测订单全流程",
      body: "订单管理覆盖待下单、待上评、待支付、完成、异常、退款等状态；支持批量操作、多维度筛选与导出，礼品单、上评管理与广告代充等增值环节一并纳入。"
    },
    {
      title: "财务结算与数据看板",
      body: "账单管理对接货款支付与对账，财务中心统筹余额与流水；数据统计汇总任务完成率、站点分布与异常原因，签收管理与实时汇率辅助跨境结算。"
    }
  ],
  tms: [
    {
      title: "承运商与运力池统一管理",
      body: "快递、专线、整车与跨境头程承运商档案、合同价目、服务等级与覆盖区域集中维护；按线路、时效与成本自动匹配最优承运方案，减少人工比价与口头约定带来的对账纠纷。"
    },
    {
      title: "智能排线与调度优化",
      body: "按订单地址、截单时间与车辆载重自动规划配送路线与装车方案，支持多点配送、拼车合单与跨区调拨；调度任务下发司机端/PDA，减少空驶与重复跑线，提升单车装载率。"
    },
    {
      title: "在途可视与异常预警",
      body: "运单全生命周期节点自动采集与轨迹回传，延误、偏航、拒收与破损等异常实时预警；客服、仓储与承运商同屏协同处理，降低客诉升级与赔付成本。"
    },
    {
      title: "运费核算与对账结算",
      body: "按重量、体积、件数与附加费规则自动试算与复核实际运费，预估与实际差异自动标红；承运商账单批量导入对账、审批留痕，缩短月结周期与财务扯皮。"
    }
  ],
  suyuan: [
    {
      title: "全链路赋码与批次管理",
      body: "支持单品码、箱码、托码多级包装赋码，按生产批次、效期与库位绑定；与 WMS 入库出库联动，扫码即知批次来源与当前所在节点，满足食品、美妆、医药等行业的追溯合规要求。"
    },
    {
      title: "原料到终端流向追踪",
      body: "从原料采购、生产加工、质检入库到仓间调拨、渠道分销与终端零售，全链路流转记录可视可查；任一节点扫码即可向上追溯原料批次、向下追踪销售去向，问题批次快速圈定影响范围。"
    },
    {
      title: "防伪验真与扫码查询",
      body: "一物一码防窜货与防伪验真，消费者扫码即可查看正品信息、生产批次与首次查询记录；异常扫码（重复、异地、高频）自动预警，助力品牌方打击假货与跨区窜货。"
    },
    {
      title: "质检合规与召回管理",
      body: "来料检验、过程质检与出厂检验记录电子化归档，检测报告与合格证随批次关联；发现质量问题可一键发起召回，自动圈定受影响批次与渠道范围，通知进度与召回数量全程可追踪。"
    }
  ],
  chat: [
    {
      title: "买卖即时沟通零等待",
      body: "下单前问规格、发货后催物流、售后扯皮都能在一个窗口搞定，消息已读、在线状态一目了然，不用加微信、不用等平台慢回复。"
    },
    {
      title: "智能客服 7×24 秒回",
      body: "常见问题、物流查询、退换政策由 AI 先答，复杂问题一键转人工；知识库随店铺更新，大促高峰也不排队。"
    },
    {
      title: "订单上下文同屏关联",
      body: "聊天里直接看到关联订单、物流轨迹与售后进度，点一下就能发起退款/改址，客服和你说的都是同一单，少重复报单号。"
    },
    {
      title: "多媒体与跨境翻译",
      body: "发图、发视频、语音都能聊；跨境买卖可开自动翻译，东南亚、欧美客户沟通更顺畅，语言不再是成交障碍。"
    }
  ]
};

/**
 * 各产品详情页：顶部综述 + 核心模块详细介绍（与 productPoints 一一对应，供详情页长文案使用）
 */
export const productDetailContent = {
  oms: {
    title: "OMS（订单管理系统）",
    overview:
      "面向品牌方、卖家与 3PL 等多店铺、多渠道企业客户，OMS 将分散在各平台的订单收口为统一履约中枢：从归集、审核、拆合单、仓配下发到物流回传与客诉协同，全程数据一致、责任可追溯。与 WMS、ERP 深度联动后，可在保障时效与客户体验的前提下显著压缩人工跟单与差错成本，让订单运营从被动救火转变为主动度量、持续优化，直接支撑履约 SLA 与经营复盘。",
    modules: [
      {
        title: "多平台订单中枢归集",
        paragraphs: [
          "对接主流跨境电商平台、独立站及企业自建前台，按店铺与业务线配置拉单策略、字段映射与主数据对齐规则。订单进入中枢后自动完成店铺、币种、SKU 与价格带校验，减少运营在多后台切换、导表拼数与口径不一带来的对内争议。",
          "对同一买家的多笔订单支持合并策略预览与仿真；对平台侧改址、取消、拆单等变更支持增量同步与版本对比，避免重复发货、漏发与平台罚则，满足 B 端客户对差错率与合规性的刚性要求。"
        ]
      },
      {
        title: "规则化拆合单与履约成本可控",
        paragraphs: [
          "拆单维度可按仓网可发量、承运产品、关务与保税要求、承诺时效与单票毛利目标组合编排；合单在满足截单时间、包装与承运约束的前提下合并出库，在客户体验与物流成本之间取得可量化平衡。",
          "策略支持灰度发布与历史订单回放，上线前即可评估对时效、费用与仓内负荷的影响，降低业务规则调整的组织风险，便于多部门（运营、仓储、财务）达成共识。"
        ]
      },
      {
        title: "履约全链路可视与协同",
        paragraphs: [
          "对内贯通仓库作业节点（拣货、复核、称重、交接承运商），对外回传平台物流单号与关键轨迹；客服、客户经理与仓内主管可在同一视图协同，发起拦截、改派或客户沟通，缩短问题响应链路。",
          "关键节点可配置 SLA 看板与订阅告警，对即将超时、异常停滞或高频客诉订单自动提醒责任人，便于管理层按客户、渠道与承运维度复盘履约质量，持续压降升级率与赔付。"
        ]
      },
      {
        title: "风险单前置拦截与留痕",
        paragraphs: [
          "内置地址不规范、黑名单、支付与风控命中、库存不足、平台处罚等常见异常模型，命中后进入待审队列并给出建议动作；可与企业自有风控与信用策略对接，避免问题单流入生产与发运环节。",
          "异常受理、审批与执行全程留痕，支持内控抽查与纠纷举证；规则命中与处理结果可回灌分析，持续收紧漏网之鱼，形成可审计的改进闭环。"
        ]
      }
    ]
  },
  hwc: {
    title: "海外仓管理系统",
    overview:
      "面向海外仓运营商、跨境 3PL 与多仓服务商等企业客户，海外仓管理系统将分散在工作台 Excel、微信群与多个子系统里的业务收口为统一运营平台：从经营看板、客户与订单管理、WMS 仓内作业到费用设置与多币种结算，全程数据一致、责任可追溯。内置发货、入库、出库、库存与对账能力，并与客户商品资料、收费模板、充值策略深度联动，让仓配服务商在承接多货主、多平台、多国家业务时仍能控制差错率、人效与定价口径，支撑对客户的服务等级协议与自身经营复盘。",
    modules: [
      {
        title: "工作台与经营看板",
        paragraphs: [
          "首页工作台汇总订单待操作量、新增客户、今日充值与消费等核心经营指标，管理层与仓内主管打开系统即可掌握当日业务脉搏，无需等待人工汇总报表。",
          "近 7 日出库订单量按泰国、印尼、菲律宾、越南、马来西亚等国家/站点拆分趋势图，支持按仓库、客户与时间维度筛选，便于识别区域波动、旺季备货与运力调配需求，让经营决策从拍脑袋转向数据驱动。"
        ]
      },
      {
        title: "客户订单与商品资料协同",
        paragraphs: [
          "客户账号、店铺、线上商品、商品资料库、店铺地址与客户管理集中维护，同一货主的多平台、多站点信息一处录入、全局可查；商品 SKU、规格、重量体积与系统编码统一沉淀，减少仓内收货与拣配时的口径不一。",
          "客户订单模块覆盖待预报、待确认、操作中、打单完成等全状态流转，列表展示用户、仓库物流、店铺批次、发货单号、平台订单与价格数量运费等关键字段，支持多维度筛选、批量操作与导出；与 WMS 出库任务、物流轨迹回传联动，让客服、客户经理与仓内作业同屏协同，缩短问题响应链路。"
        ]
      },
      {
        title: "WMS 仓内作业一体化",
        paragraphs: [
          "内置发货管理、出库日志、入库管理、库存管理与仓库对账模块，无需额外对接即可跑通仓内主流程；入库支持运单入库、退货入库、调拨入库等场景，按运输中、已到仓、收货中、待上架、已完成等状态全程可视。",
          "入库单展示质检/入库/总箱数、预计与实际数量体积、创建/预计/入仓时间与仓库仓位等关键信息，收货、上架操作与 OMS 下发单号严格对应；出库波次、拣配与承运交接节点扫码校验，差异与异常即时记录，满足 B 端客户对差错可追溯与对账可举证的要求。"
        ]
      },
      {
        title: "费用设置与多币种结算",
        paragraphs: [
          "费用设置模块集中维护基础费用、外汇设置、收款设置、充值设置与折扣设置：基础费用支持佣金提成、评测发货、超材费、仓库发货、贴标费、仓租费等收费项按单价与单位（%、/单元、元/m³ 等）灵活配置，仓租费用可单独分层设置，满足不同货主与业务线的差异化定价。",
          "外汇设置维护菲律宾比索、越南盾、泰铢、印尼盾、马来币、新加坡元等多币种双向汇率与手续费，支持自动结余外汇与结算时间配置；收款设置统一管理微信、支付宝与各银行收款账号及充值渠道二维码，充值设置可配置线上线下充值策略、汇付/汇聚等支付通道概率与最低充值门槛，折扣设置按用户、仓库与费用类型（贴标费、上架费、仓租等）设定有效期与折扣系数，让 3PL 收费规则在线化、可追溯、少扯皮。"
        ]
      }
    ]
  },
  wms: {
    title: "WMS（仓储管理系统）",
    overview:
      "面向海外仓运营商、品牌自营仓与 3PL 等企业客户，WMS 覆盖入库、在库、出库与盘点全链路，以「账实一致」与「可度量人效」为双目标：在业务扩张期仍能控制差错率、劳动工时与库存资金占用。通过与 OMS、ERP 的深度集成，可售量、实物移动与成本口径同步更新，为前台销售承诺、采购补货与财务核算提供同一套可信库存底座，支撑规模化履约与对客户的服务等级协议。",
    modules: [
      {
        title: "企业级多仓与库内建模",
        paragraphs: [
          "仓库、库区、通道、货位多级结构可配置，支持批次、效期、序列号等维度，满足普货、带电、冷链、高货值等不同存储与追溯策略。多仓之间支持调拨、可售共享与安全水位策略，适配海外仓、保税仓与国内仓的组合布局。",
          "库位与 SKU 绑定策略可按品类与周转分层调整，动态与固定库位混合使用，在库容利用与拣货效率之间随阶段优化，降低扩仓与搬仓的改造成本。"
        ]
      },
      {
        title: "标准化入库出库与波次作业",
        paragraphs: [
          "入库支持 ASN 预约、到货清点、质检与上架任务联动，差异与异常即时记录；出库按波次、快递截单、承运分区与客户优先级生成任务队列，并与 OMS 下发单号严格对应，减少口头协调与纸质单据。",
          "关键节点扫码或复核校验，降低错拣错发率；对短拣、多发与货损触发复盘与责任界定流程，满足 B 端客户对差错可追溯与对账可举证的要求。"
        ]
      },
      {
        title: "拣货动线与人效优化",
        paragraphs: [
          "按订单结构（单品单件、多品多件）与库位热力生成拣货批次，优化行走距离与拣货车满载；支持按单拣、按区接力、边拣边分等模式，按业务峰谷灵活切换。",
          "可与电子标签、PDA、语音拣选及后续自动化设备对接，企业可按投资回报节奏分阶段投入，用作业数据持续验证人效提升与差错下降。"
        ]
      },
      {
        title: "账实一致与中台联动",
        paragraphs: [
          "上架、拣货、复核、发运与盘盈亏等事件实时回写中台，可售量与平台库存同步策略可配置，在降低超卖风险的同时避免频繁改价对前台运营的干扰。",
          "提供库存快照、收发存与对账报表，支持按日、按仓、按货主与平台侧库存比对，缩短月结与审计时的差异处理周期，支撑精细化仓储成本核算。"
        ]
      }
    ]
  },
  erp: {
    title: "ERP（进销存与经营管理系统）",
    overview:
      "给跨境电商卖家和小团队用的进销存与算账工具：进货、库存、成本与日常对账收进一个系统，告别 Excel 拼表和微信群对账。采购到货、各仓可售、单品毛利与货款占用同屏可见，两三个人也能把账算清楚——知道赚在哪、亏在哪、货该不该补，做大了再平滑升级更复杂的业财能力。",
    modules: [
      {
        title: "进货下单到货一站管",
        paragraphs: [
          "从下单、催货到货到对账全流程在线，供应商交期、在途数量与到货差异一处查看，少靠截图和口头确认。可按 SKU 设置安全库存与补货提醒，结合各平台销量自动建议采购量，在少断货和不囤死货之间找到平衡。",
          "采购价、运费、关税可按批次归集到单品，后续算毛利、做促销清仓都有统一成本底数，月底对账不用再从多个表格里手工拼数。"
        ]
      },
      {
        title: "每件货真实成本算得清",
        paragraphs: [
          "支持多币种采购与跨境结算，把平台扣点、广告、头程、仓储等费用摊到 SKU 和订单级，看清每一件货、每一单到底是赚是亏，而不是只看平台后台的「表面成交额」。",
          "日常收支与货款流水可对照，减少「感觉赚了、对账对不上」的困惑；关键数字可按日、按店铺导出，方便自己复盘或交给兼职财务处理。"
        ]
      },
      {
        title: "库存占了多少货款心里有数",
        paragraphs: [
          "国内仓、海外仓与各平台可售库存联动展示，周转慢、快断货、压货款高的 SKU 自动标出，补货和清仓决策更有依据，少让呆滞库存占住本可以周转的现金。",
          "与 OMS、WMS 对接后，销售出库与库存扣减自动同步，前台承诺的可售量与后台实物账对齐，降低超卖和「账上有货、仓里没货」的扯皮成本。"
        ]
      },
      {
        title: "小团队也能分工协作",
        paragraphs: [
          "多店铺、多仓库可按角色分配权限，采购、运营、仓储、财务各管一块又数据同源，两三个人的小团队不用上大系统也能把日常进销存跑顺。",
          "常用报表与对账清单开箱即用，不用啃复杂科目和合并规则；业务做大了可逐步解锁多账套、更细成本分摊等进阶能力，保护前期投入。"
        ]
      }
    ]
  },
  drp: {
    title: "DRP（分销系统）",
    overview:
      "面向品牌方、总经销与区域大商等企业客户，DRP 在拓展分销网络的同时守住三条底线：价盘可控、库存可视、资金可回笼。通过经销商主数据、授信、价目与分货策略的在线化与留痕，减少跨区窜货、乱价与对账扯皮；与 OMS、WMS、ERP 联动后，渠道订单与总仓/前置仓库存、应收账龄同屏呈现，便于销售管理与财务风控协同，让渠道增长从「堆人头」转为「可复制的体系能力」。",
    modules: [
      {
        title: "经销商主数据与授信管控",
        paragraphs: [
          "经销商档案、合同、经营资质、等级与授信额度集中维护，可售 SKU、区域与价格带按政策自动约束；下单、发运与回款状态实时可查，渠道经理可按客户健康度与逾期风险分层跟进。",
          "与 OMS 订单履约、财务应收与信用占用联动，支撑「先款后货」「额度滚动」等多种 B 端结算习惯，降低坏账与操作风险。"
        ]
      },
      {
        title: "多级渠道与业绩归属清晰",
        paragraphs: [
          "支持省代、市代、门店及电商分销等多级结构，业绩归属可按下单方、服务方、引流方等维度配置；返利、阶梯价与活动政策按时间窗与适用范围发布，结算规则透明可追溯。",
          "渠道架构调整时可平滑迁移历史业绩与未结返利，降低年度关账与渠道大会上的争议成本，便于总部与区域管理共识。"
        ]
      },
      {
        title: "价盘与特价审批留痕",
        paragraphs: [
          "价目表与渠道特价分层管理，突破底价、特价与样品政策走审批并全程留痕；促销与套装可单独定价，减少一线随意折价对品牌与毛利体系的冲击。",
          "可与平台大促、直播专场等节奏协同，在冲量的同时区分直营与渠道利益，降低「价格战」对忠诚经销商的伤害。"
        ]
      },
      {
        title: "分货与库存协同",
        paragraphs: [
          "分销订单可路由至总仓或区域前置仓，可售共享、安全水位与分货策略可配置，分货、调拨与在途全程可视，降低渠道断货、重复备库与总部拍脑袋分货。",
          "退货、拒收与售后单与财务核销、信用释放联动，缩短渠道资金占用周期，支撑总部对渠道库存与应收的例行复盘。"
        ]
      }
    ]
  },
  bi: {
    title: "BI（数据分析系统）",
    overview:
      "专为个人店主、中小卖家和小团队打造：把订单、库存、广告和平台后台里散落的数字，变成你看得懂、点得动的图表。不用啃复杂表格，也能随时回答「今天赚了多少」「哪个链接在拖后腿」「该不该补货」——让你少熬夜对账，多把时间花在选品和冲量上。",
    modules: [
      {
        title: "多店铺业绩随时看",
        paragraphs: [
          "把多店铺、多站点的销量、订单和成交额拢在一屏，按链接、SKU 或活动筛一筛，一眼看出谁在爆、谁在跌。支持看看今天、这周或自定义时段，再也不用为了对个数切十几个后台、下十几张表。",
          "若你在冲目标或大促盯盘，还能快速对比昨天、上周同期，心里对「完成进度」有数，调整投放和库存更有底气。"
        ]
      },
      {
        title: "成本厘清，真赚钱才继续做",
        paragraphs: [
          "把平台佣金、广告花费、头程运费、仓储和退货摊到单品和订单上，算出「到手还能剩多少」。哪些爆款其实在贴钱、哪些长尾在偷偷吞利润，图表上直接标出来，帮你决定要不要加码投流、要不要降价清仓。",
          "不必是财务出身：常用口径已经配好，你只要关心「赚不赚、赚在哪」，复杂分摊交给系统，减少拍脑袋定价和盲目烧广告。"
        ]
      },
      {
        title: "库存心里有数，少压货款",
        paragraphs: [
          "哪些货卖不动、哪些快断货、哪些占着仓库费，用颜色或排行拉一眼就知道。补货怕断码、清货怕割肉时，先看数据再动手，少让呆滞库存占住现金。",
          "若你多仓备货或海外仓发货，也能对比各仓动销，避免「这边断货、那边积压」的尴尬，让每一分钱库存尽量转起来。"
        ]
      },
      {
        title: "图表报告零门槛",
        paragraphs: [
          "预置好看好懂的经营看板、日报和专题页，拖拽时间、店铺就能切换视角；需要给合伙人或小伙伴看时，一键导出或分享，少做重复截图和手工汇报。",
          "关键指标可设提醒：销量异常、广告超支、库存预警推送到微信或邮箱，大促不用整夜刷后台，重要变化主动找你。"
        ]
      }
    ]
  },
  tms: {
    title: "TMS（运输管理系统）",
    overview:
      "面向品牌方、3PL 与跨境物流服务商等企业客户，TMS 将分散在 Excel、微信群与承运商后台的运输业务收口为统一调度中枢：从承运商管理、运单创建、智能排线、在途监控到运费核算与对账结算，全程数据一致、责任可追溯。与 OMS、WMS 深度联动后，订单下发即自动生成运单与拣配任务，物流轨迹实时回传前台与客服系统，在保障时效与客户体验的前提下显著压缩人工跟单、空驶浪费与运费差异成本，让运输运营从被动救火转变为主动度量、持续优化。",
    modules: [
      {
        title: "承运商与运力池统一管理",
        paragraphs: [
          "支持快递、快运、专线、整车、冷链与跨境头程等多类型承运商档案集中维护，合同价目、服务等级协议（SLA）、覆盖区域、截单时间与附加费规则可配置；按线路、重量段与时效承诺自动匹配候选承运方案，减少运营在多承运商后台切换比价与口头约定带来的口径不一。",
          "承运商绩效看板汇总准时率、破损率、客诉率与对账差异等指标，支持按季度复盘与优胜劣汰；新承运商接入可走审批与试跑期，降低切换承运商的组织风险与业务中断成本。"
        ]
      },
      {
        title: "智能排线与调度优化",
        paragraphs: [
          "按订单收货地址、承诺时效、车辆载重与仓库出仓时间自动规划配送路线，支持同城多点配送、跨区拼车合单与仓间调拨运输；排线结果可人工微调并仿真评估对时效与成本的影响，上线前即可验证策略合理性。",
          "调度任务一键下发司机端 App 或 PDA，司机接单、装车、发车、签收等节点扫码回传；单车装载率、行驶里程与配送时效可度量，持续优化排线算法与运力配置，降低空驶与重复跑线浪费。"
        ]
      },
      {
        title: "在途可视与异常预警",
        paragraphs: [
          "运单全生命周期节点（揽收、中转、派送、签收、拒收）自动采集并与 OMS 订单状态同步；GPS 轨迹、电子回单与签收照片集中归档，客服与客户可在同一视图查询物流进度，减少反复报单号与截图。",
          "延误、偏航、长时间未更新、拒收与破损等异常模型可配置告警规则，命中后自动通知责任人并生成待办；异常处理路径与赔付记录留痕，便于按承运商、线路与客户维度复盘服务质量，持续压降升级率。"
        ]
      },
      {
        title: "运费核算与对账结算",
        paragraphs: [
          "按重量、体积、件数、距离与附加费（偏远、上楼、保价等）规则自动试算预估运费，实际账单导入后自动比对差异并标红待核；支持多币种跨境运费分摊到 SKU 或订单级，为 ERP 成本核算提供统一口径。",
          "承运商账单批量导入、三方对账与审批留痕，缩短月结周期；运费分析报表按线路、承运商与客户维度呈现成本结构，为议价、换承运与定价策略提供数据支撑，降低「感觉运费高、对账对不上」的内耗。"
        ]
      }
    ]
  },
  suyuan: {
    title: "溯源系统",
    overview:
      "面向食品、美妆、医药、母婴与高端消费品等品牌方与生产企业，溯源系统以「一物一码、全链可查、问题可追、假货可防」为目标：从原料采购、生产加工、质检入库到仓间调拨、渠道分销与终端零售，每一环节的流转记录实时采集并与批次绑定。与 WMS、DRP、OMS 联动后，扫码即可向上追溯原料来源、向下追踪销售去向，质量问题可快速圈定影响范围并发起召回；消费者扫码验真增强品牌信任，异常扫码预警助力打击窜货与假货，满足监管合规与品牌风控的双重需求。",
    modules: [
      {
        title: "全链路赋码与批次管理",
        paragraphs: [
          "支持单品码、箱码、托码多级包装赋码策略，按 SKU、生产批次、效期与质检状态生成唯一标识；赋码规则可对接生产线喷码设备或离线预生成，入库扫码自动绑定库位与货主，出库扫码自动更新流向节点。",
          "批次主数据集中维护生产日期、保质期、原料批次、生产工单与质检报告等关键属性，与 WMS 库存账实时同步；临期、过期与锁定批次自动预警，支持按批次冻结销售与调拨，降低合规风险与客诉成本。"
        ]
      },
      {
        title: "原料到终端流向追踪",
        paragraphs: [
          "从原料采购入库、生产加工领料、成品质检入库，到仓间调拨、渠道出库与终端零售签收，全链路流转事件自动采集并形成可视化时间轴；任一节点扫码即可向上追溯原料供应商与生产批次，向下追踪经销商与终端门店，问题批次影响范围一目了然。",
          "渠道分销与 DRP 联动，出库扫码自动记录经销商与区域归属，跨区销售与窜货行为可识别预警；跨境场景支持报关单号、目的国与海外仓节点关联，满足进出口追溯与合规审计要求。"
        ]
      },
      {
        title: "防伪验真与扫码查询",
        paragraphs: [
          "一物一码绑定产品信息与首次查询记录，消费者微信/浏览器扫码即可查看正品验证结果、生产批次、生产日期与品牌官方信息；重复扫码、异地高频扫码与疑似假货扫码自动预警，推送至品牌风控与渠道管理部门。",
          "验真页面支持多语言与品牌自定义样式，可嵌入小程序、官网与产品包装；扫码数据沉淀为营销洞察（地域分布、用户画像、复购关联），在保障防伪的同时赋能精准营销与渠道分析。"
        ]
      },
      {
        title: "质检合规与召回管理",
        paragraphs: [
          "来料检验（IQC）、过程检验（IPQC）与出厂检验（OQC）记录电子化归档，检测项目、结果、报告附件与责任人随批次关联；不合格品隔离、让步接收与退货流程在线留痕，满足 ISO、GMP 与行业监管审计要求。",
          "发现质量问题可一键发起召回，系统自动圈定受影响批次、在库数量、在途订单与已售终端范围，生成召回任务清单并按渠道推送通知；召回进度、回收数量与销毁记录全程可追踪，支持向监管部门导出合规报告，降低舆情与法律风险。"
        ]
      }
    ]
  },
  pingce: {
    title: "评测系统（EMS）",
    overview:
      "驿店 EMS 评测系统是面向跨境电商企业与评测服务商的任务协同平台：企业按店铺与站点发布评测、引流、真实单等任务并设定佣金与排期，刷手在线接单完成下单、签收、上评；平台统一管理多平台店铺、买手账号、订单状态与货款结算，让评测业务分工清晰、进度可视、资金可追溯，替代 Excel 跟单与群聊派单的低效模式。",
    modules: [
      {
        title: "店铺与多平台管理",
        paragraphs: [
          "支持 Shopee、TikTok、Amazon 等主流跨境平台店铺绑定，按平台、站点、店铺名称集中维护商品链接、负责人与业务归属；多店、多站点信息一处录入，任务创建时直接选用，避免运营在多个后台反复切换。",
          "店铺维度可关联历史任务量、完成率与异常记录，便于按站点评估投放效果；与订单、账单模块数据打通，同一店铺下的评测单、引流单、真实单可统一检索与对账。"
        ]
      },
      {
        title: "任务中心与刷手协同",
        paragraphs: [
          "任务中心拆分评测任务、下单任务、上评任务等子模块，企业发布任务后进入待确认、待下单、待上评、待支付、完成等状态流转；刷手在任务池抢单或接受指派，买手账号与刷手档案联动，保障执行账号合规可用。",
          "支持按计划时间、评测平台、站点、订单类型（评测单/引流单/真实单/延迟下单）等多维筛选；批量操作、导出与排期任务让大批量评测活动可管可控，异常与退款单单独跟踪处理。"
        ]
      },
      {
        title: "评测订单全流程管理",
        paragraphs: [
          "订单管理模块覆盖从草稿、待确认到完成、已拒绝、异常、退款、已关闭的全生命周期；列表展示提交/下单/上评时间、系统单号、平台订单号、店铺站点、下单说明与给评计划，运营一眼掌握每笔任务进度。",
          "增值环节纳入同一体系：礼品订单管理实物发货、上评管理跟进评价内容与截图、广告代充/广告补充处理推广预算；签收管理确保物流节点齐全，降低平台风控与客诉风险。"
        ]
      },
      {
        title: "财务结算与数据统计",
        paragraphs: [
          "账单管理按待支付、待审核、已完成等状态汇总货款与佣金，支持按账单时间、支付方式、商户、站点筛选；待支付清单可批量「支付货款」，底部汇总待付总额，日处理万级账单仍清晰可控。",
          "财务中心统筹企业余额、刷手结算与平台流水；数据统计提供任务完成率、站点分布、异常原因等经营看板，实时汇率辅助多币种跨境结算，为管理层复盘评测 ROI 与优化投放策略提供依据。"
        ]
      }
    ]
  },
  chat: {
    title: "聊天系统",
    overview:
      "给卖家和买家用的即时沟通中枢：售前问清楚、售中跟得紧、售后不扯皮。订单、物流、售后上下文自动带进会话，AI 先答常见问题、人工接手复杂单，还支持图片视频与跨境翻译——让你少雇客服、买家少等待，沟通体验直接拉动转化与复购。",
    modules: [
      {
        title: "买卖即时沟通零等待",
        paragraphs: [
          "店铺内一键发起会话，支持 Web、App 与小程序多端同步；消息送达、已读状态与「对方正在输入」实时可见，买家不用加私人微信也能问规格、催发货、协商售后。",
          "常用语、快捷回复与商品卡片一键发送，客服效率倍增；会话可按未读、待回复、已完结分组，大促期间也能有序接单，避免漏回导致差评与流失。"
        ]
      },
      {
        title: "智能客服 7×24 秒回",
        paragraphs: [
          "基于店铺 FAQ、物流政策与历史对话训练的智能助手，可自动回答库存、尺码、发货时效、退换规则等高频问题；复杂或情绪升级会话无缝转接人工，并携带 AI 摘要供客服快速接手。",
          "知识库支持富文本与多语言条目，上新、改价、大促规则更新后同步生效；接待量、解决率与转人工率可视化，持续优化话术与自助覆盖率，夜间与节假日也不掉线。"
        ]
      },
      {
        title: "订单上下文同屏关联",
        paragraphs: [
          "会话侧边栏自动展示关联订单、支付状态、物流轨迹与售后单进度；客服与买家讨论的是同一笔货，改址、催派、发起退款/退货可在聊天内一键跳转，减少反复报单号与截图。",
          "历史会话按订单归档，纠纷处理时可完整回放沟通记录；与 OMS、WMS 状态联动，物流异常、签收失败等事件可主动推送消息给买家，变被动答疑为主动服务。"
        ]
      },
      {
        title: "多媒体与跨境翻译",
        paragraphs: [
          "支持发送图片、短视频、语音与文件，买家拍瑕疵、客服发安装视频都方便；消息云端存储可检索，便于质检与培训复盘。",
          "跨境场景可开启实时双向翻译，泰语、英语、中文等常用语种自动转换并保留原文对照；配合多时区在线时段设置，让东南亚、欧美客户感受「本地店」般的沟通体验，语言不再挡成交。"
        ]
      }
    ]
  }
};

export const defaultProducts = [
  {
    id: "prd-hwc",
    audience: "b",
    name: "海外仓管理系统",
    subtitle:
      "海外仓 3PL 一体化运营平台：工作台看板、客户订单、WMS 仓内作业、费用设置与多币种结算一站打通，多货主多国家可管可控。",
    image: require("@/static/hwc/home.png"),
    icon: require("@/static/HWC.png"),
    intro: "面向海外仓运营商与跨境 3PL，将看板、客户、仓配、财务与权限收口为统一平台，支撑规模化服务多货主。",
    points: productPoints.hwc,
    link: ""
  },
  {
    id: "prd-oms",
    audience: "b",
    name: "OMS（订单管理系统）",
    subtitle:
      "企业级订单中台：多渠道订单统一归集与规则化履约，降差错、控成本、全程可追溯，直连仓配与财务。",
    image: require("@/static/official/core-feature-2.jpg"),
    icon: require("@/static/official/icon-oms.png"),
    intro: "面向多店铺、多渠道企业客户，将订单收口为统一履约中枢，支撑 SLA 与经营复盘。",
    points: productPoints.oms,
    link: ""
  },
  {
    id: "prd-wms",
    audience: "b",
    name: "WMS（仓储管理系统）",
    subtitle:
      "企业级仓储作业平台：多仓精细化与波次化作业，账实一致、人效可度量，深度联动订单与采购财务。",
    image: require("@/static/official/core-feature-3.jpg"),
    icon: require("@/static/WMS.jpg"),
    intro: "面向海外仓、3PL 与品牌自营仓，以账实一致与可度量人效支撑规模化履约。",
    points: productPoints.wms,
    link: ""
  },
  {
    id: "prd-erp",
    audience: "c",
    name: "ERP（进销存与经营管理系统）",
    subtitle:
      "给卖家和小团队用的进销存算账工具：进货、库存、成本与对账一处搞定，少靠 Excel 拼表，随时知道赚在哪、货该不该补。",
    image: require("@/static/official/hero-bg.jpg"),
    icon: require("@/static/official/icon-erp.png"),
    intro: "两三个人也能把进货、库存和日常对账跑顺，做大了再平滑升级更复杂的业财能力。",
    points: productPoints.erp,
    link: ""
  },
  {
    id: "prd-drp",
    audience: "b",
    name: "DRP（分销系统）",
    subtitle:
      "企业级渠道治理：价盘、授信、分货与业绩归属在线可控，减少窜货乱价与对账纠纷，可复制扩张分销网络。",
    image: require("@/static/official/product-drp.jpg"),
    icon: require("@/static/DRP.jpg"),
    intro: "面向品牌方与总经销，在放大渠道规模的同时守住价盘、库存与资金三条底线。",
    points: productPoints.drp,
    link: ""
  },
  {
    id: "prd-bi",
    audience: "c",
    name: "BI（数据分析系统）",
    subtitle:
      "给店主和小团队用的经营参谋：多店一屏看懂销量与利润，库存与广告不踩坑，图表零门槛，大促盯盘少熬夜。",
    image: require("@/static/official/core-feature-4.jpg"),
    icon: require("@/static/BI.jpg"),
    intro: "不用啃表格，也能随时知道赚在哪、亏在哪、货该不该补。",
    points: productPoints.bi,
    link: ""
  },
  {
    id: "prd-tms",
    audience: "b",
    name: "TMS（运输管理系统）",
    subtitle:
      "企业级运输调度平台：承运商统一管理、智能排线调度、在途全程可视、运费自动核算对账，深度联动订单与仓储。",
    image: require("@/static/tms/home.png"),
    icon: require("@/static/TMS.jpg"),
    intro: "面向品牌方与 3PL，将运输业务收口为统一调度中枢，降空驶、控运费、全程可追溯。",
    points: productPoints.tms,
    link: ""
  },
  {
    id: "prd-suyuan",
    audience: "b",
    name: "溯源系统",
    subtitle:
      "全链路产品追溯平台：一物一码赋码、原料到终端流向追踪、防伪验真扫码、质检合规与召回管理，满足监管与品牌风控。",
    image: require("@/static/suyuan/home.png"),
    icon: require("@/static/SUYUAN.jpg"),
    intro: "面向食品、美妆、医药等品牌方，让每一批次可查、可追、可防、可召回。",
    points: productPoints.suyuan,
    link: ""
  },
  {
    id: "prd-pingce",
    audience: "c",
    name: "评测系统（EMS）",
    subtitle:
      "跨境电商评测任务协同平台：企业发布任务、刷手在线接单，店铺/订单/买手/货款一站式管理，全流程可视、资金可追溯。",
    image: require("@/static/pingce/home.png"),
    icon: require("@/static/EMS.jpg"),
    intro: "替代 Excel 跟单与群聊派单，让评测业务从发任务到上评结算都在一个系统里跑通。",
    points: productPoints.pingce,
    link: ""
  },
  {
    id: "prd-chat",
    audience: "c",
    name: "聊天系统",
    subtitle:
      "买卖即时聊：AI 秒回常见问题，订单物流售后同屏关联，还支持图片视频与跨境翻译，沟通不扯皮、转化更顺畅。",
    image: require("@/static/chat/home.png"),
    icon: require("@/static/IM.jpg"),
    intro: "售前问清楚、售中跟得紧、售后不重复报单号，一个窗口全搞定。",
    points: productPoints.chat,
    link: ""
  }
];
